export default {
    ai: 'AI Assistant',
    export: 'Export',
    blue: 'Blue',
    yellow: 'Yellow',
    pink: 'Pink',
    orange: 'Orange',
    all: 'All',
    generateApaCopy: 'Generate APA citation',
    apaCopied: 'Citation copied to clipboard!',
    imReading: `I'm reading`,
    in: 'in',
    by: 'By',
    article: 'Article',
    prevArticle: 'Previous Article',
    nextArticle: 'Next Article',
    imHere: `Yes, I'm here`,
    sessionExpiredAlert: 'Your reading session is about to end.',
    sessionExpiredAreYouThere: 'Are you there?',
    sessionExpired: 'Your reading session has expired due to inactivity.',
    returnToLibrary: 'Return to library',
    sessionValidExpired: 'Session expired',
    sessionValidExpiredPleaseLoginAgain: 'Please login again',
    tableOfContents: 'Table of Contents',
    tableOfContentsNotAvailable: 'No table of contents available.',
    pages: 'pages',
    page: 'page',
    thumbnails: 'Thumbnails',
    settings: 'Settings',
    bookmarks: 'Bookmarks',
    highlights: 'Highlights',
    highlight: 'Highlight',
    notes: 'Notes',
    note: 'Note',
    notebook: 'Notebook',
    search: 'Search',
    theme: 'Theme',
    readingModes: 'Reading modes',
    zoomTitle: 'Text size',
    zoomTitlePdf: 'Zoom',
    zoomTimes: 'Times',
    typography: 'Typography',
    fontDefault: 'Default',
    lineSpacing: 'Line Spacing',
    lineSpacingCompact: 'Compact',
    lineSpacingNormal: 'Normal',
    lineSpacingWide: 'Wide',
    margins: 'Margins',
    marginsMinimum: 'Minimum',
    marginsNormal: 'Normal',
    marginsMaximum: 'Maximum',
    pageLayout: 'Page Layout',
    continuous: 'Continuous',
    onePage: 'Horizontal',
    onePageScroll: 'Vertical',
    twoPages: 'Double',
    twoPagesScroll: 'Two pages scrolling',
    citation: {
        buttons: {
            Iso690: 'Generate ISO690 citation',
            APA: 'Generate APA citation',
            Vancouver: 'Generate Vancouver citation',
            Chicago: 'Generate Chicago citation',
            ChicagoNotes: 'Notes',
            ChicagoBibliography: 'Bibliography',
            ChicagoAuthorDate: 'Author-Date',
            IEEE: 'Generate IEEE citation',
            MLA: 'Generate MLA citation',
            ABNT: 'Generate ABNT citation',
        },
        menu: {
            title: 'Generate citation',
            Iso690: 'ISO690 Citation',
            APA: 'APA Citation',
            Vancouver: 'Vancouver Citation',
            Chicago: 'Chicago Citation',
            ChicagoNotes: 'Notes',
            ChicagoBibliography: 'Bibliography',
            ChicagoAuthorDate: 'Author-Date',
            IEEE: 'IEEE Citation',
            MLA: 'MLA Citation',
            ABNT: 'ABNT Citation',
        },
        messages: {
            copied: '¡Citation copied to clipboard!',
            availableIn: 'Available in',
            online: 'Internet',
            generated: 'cited',
            websiteName: 'publica.la',
            and: 'and',
        },
    },
    'ai-integrations': {
        buttons: {
            explain: 'Explain concept',
            expand: 'Expand information',
            summarize: 'Summarize idea',
        },
        menu: {
            title: 'AI Assistant (Beta)',
        },
        messages: {
            copied: '¡Response copied to clipboard!',
            addedToResponse: '«Response copied from publica.la Reader»',
        },
        thanksFeedback: '¡Thanks for your feedback!',
        errorFeedback: 'Sending feedback failed. ¿Can you retry?',
    },
    onlyCopy: 'Copy plain text',
    translate: 'Translate',
    copy: 'copy',
    changeColor: 'Change color',
    socialShare: 'Share',
    zoom: {
        auto: 'Auto',
        'page-fit': 'Page Fit',
        'page-width': 'Page Width',
    },
    filter: 'Filter',
    noFilterHighlights: 'Select a filter to see your highlights',
    noFilterHighlightsColor: 'There is nothing highlighted in this color',
    noHighlights: 'You have not made highlights yet',
    noFilterNotes: 'Select a color to see your notes',
    noFilterNotesColor: 'There are no notes of this color',
    noNotes: 'You have not written notes yet',
    noFilterHighlightsAndNotes: 'Select a color to see your highlights and notes',
    noFilterHighlightsAndNotesColor: 'There is no notes or highlights of this color',
    noHighlightsAndNotes: 'You have not created any highlights or notes yet',
    plainCopied: 'Text copied to clipboard!',
    onboarding: {
        next: 'Next',
        finish: 'Finish',
        skip: 'Skip tutorial',
        previous: 'Previous',
        reader: {
            welcome: {
                title: 'Welcome to your reading space',
                paragraph: 'Discover how to make the most of your books with the tools available in the reader.',
                extraParagraph: 'Enjoy your new reading space!',
            },
            highlights: {
                title: 'Enhance your reading experience',
                paragraph:
                    'Select text, highlight, create notes, generate quotes, translate, and listen to content. Take your reading experience to the next level in all formats.',
            },
            resumes: {
                title: 'Manage your content',
                paragraph:
                    'Boost your productivity. Manage your notes, highlights, quotes, and summaries at your convenience. Share your ideas quickly and easily.',
            },
            appPromote: {
                title: 'Read or listen anywhere',
                paragraph:
                    'Access your content whenever and however you want, without the need for an internet connection, on the device of your choice.',
                extraParagraph: 'Download our app!',
            },
        },
        audiobook: {
            welcome: {
                title: 'Welcome',
                subTitle: 'How to use the Audio Player?',
                paragraph: 'Learn how to make the most of your listening.',
            },
            reproduction: {
                title: 'Playback control',
                paragraph: 'Go back and forth, or pause audiobook playback.',
            },
            narratorSpeed: {
                title: 'Narration speed',
                paragraph: 'You can choose any speed you prefer with the audiobook currently listened to.',
            },
            chapters: {
                title: 'Chapters',
                paragraph: 'Move between chapters in an agile and fast way.',
            },
        },
    },
    author: 'Author',
    publisher: 'Publisher',
    narrator: 'Narrator',
    narratedBy: 'Narrated by',
    aboutThisPublication: 'About this publication',
    listening: {
        label: 'Listen',
        voice: 'Voice',
    },
    searchResultEmpty: 'No results found',
    searchLengthError: 'Search must be between 4 and 128 characters',
    keepTyping: 'Keep typing…',
    loading: 'Loading...',
    searchLoading: 'Searching...',
    searchTitle: 'Search',
    lastSearch: 'Suggestions',
    searchExplanation: 'Find words in an agile way on all publication',
    networkIsOffline: 'No internet connection available. Some features are unavailable.',
    about: 'About',
    chapters: 'Chapters',
    duration: 'Duration',
    narratorSpeed: 'Narrator speed',
    slowNarration: 'Slow storytelling',
    normalNarration: 'Normal storytelling',
    fastNarration: 'Fast storytelling',
    shareIssue: 'Share publication',
    shareArticle: 'Share Article',
    copyUrl: 'Copy URL',
    shareCurrentPage: 'Share current page',
    shareCurrentPosition: 'Share current position',
    copyUrlToClipboard: 'URL copied to clipboard',
    tooltips: {
        zoomOut: 'Zoom out',
        zoomIn: 'Zoom in',
        config: 'Configuration',
        tableOfContents: 'Table of contents',
        search: 'Search',
        highlights: 'Highlights',
        notebook: 'Notebook',
        listen: 'Listen',
        bookmarks: 'Bookmarks',
        openThumbnails: 'Thumbnails',
        closeThumbnails: 'Exit thumbnails',
        download: 'Offline Access',
        share: 'Share',
        prev: 'Prev',
        next: 'Next',
        close: 'Close',
        back: 'Back',
        themeTitle: 'Appearance',
        themeLight: 'Light',
        themeDark: 'Dark',
        themeCream: 'Cream',
        themeSepia: 'Sepia',
        themeCyan: 'Cyan',
        themeHighContrast: 'High contrast',
        themeHighContrastDark: 'High contrast dark',
        clear: 'Clear',
        citation: 'Citation',
        dictionary: 'Dictionary',
        aiIntegrations: 'AI Assistant (Beta)',
        aiAction:
            'This tool uses AI, so there may be inaccurate information. More improvements coming soon! What do you think? Use the icons below to share your thoughts.',
        translate: 'Translate',
        about: 'About',
        rewind: 'Rewind',
        forward: 'Forward',
        createNote: 'Create a note',
        createHighlight: 'Highlight',
        deleteHighlight: 'Delete highlight',
        help: 'Help',
        lists: 'Lists',
        copy: 'Copy',
        goodResponse: 'Good response',
        badResponse: 'Bad response',
        ai: 'AI assistant',
        moreActions: 'More actions',
        moreOptions: 'More options',
        selectionTools: 'Selection tools',
        play: 'Play',
        pause: 'Pause',
        seekPosition: 'Track position',
        zoomReset: 'Reset zoom',
        smartZoom: 'Smart Zoom',
        themeSystem: 'System theme',
        searchInBook: 'Search in book',
        pageSlider: 'Page navigation',
    },
    save: 'Save',
    delete: 'Delete',
    cancel: 'Cancel',
    confirmDelete: {
        title: 'Delete notebook',
        message: 'Are you sure you want to delete this notebook? This action cannot be undone.',
    },
    confirmResetSettings: {
        title: 'Reset settings',
        message: 'All visual settings will be restored to their default values.',
    },
    resetSettings: 'Reset settings',
    writeNote: 'Write a note',
    speakNow: 'Speak now',
    listeningSpeech: 'Listening',
    share: {
        copyShare: 'Copy and share',
        qrCodeTitle: 'QR Code',
        scanQr: 'Scan the QR code using your WeChat app',
        copyLink: 'Copy the publication URL',
        copy: 'Copy',
        copied: 'copied!',
        openWechat: 'Open WeChat app',
        openingWechat: 'Opening WeChat app...',
        sendCopiedUrl: 'Send copied URL to a contact',
    },
    playing: 'Playing',
    buyNow: 'Buy now',
    buyNowText: 'Get the full version.',
    preview: 'Sample',
    changeLayoutNotAllowed: 'The content does not allow to change the page layout',
    nativeTtsLang: {
        'en-US': 'English (United States)',
        'en-GB': 'English (United Kingdom)',
        'en-scotland': 'English (Scotland)',
        'en-AU': 'English (Australia)',
        'en-IE': 'English (Ireland)',
        'en-IN': 'English (India)',
        'en-ZA': 'English (South Africa)',
        en: 'English',
        'es-AR': 'Spanish (Argentina)',
        'es-ES': 'Spanish (Spain)',
        'es-MX': 'Spanish (Mexico)',
        'es-US': 'Spanish (United States)',
        es: 'Spanish',
        'it-IT': 'Italian (Italy)',
        it: 'Italian',
        'pt-PT': 'Portuguese (Portugal)',
        'pt-BR': 'Portuguese (Brazil)',
        pt: 'Portuguese',
        'fr-CA': 'French (Canada)',
        'fr-FR': 'French (France)',
        fr: 'French',
        pl: 'Polish',
        'pl-PL': 'Polish (Poland)',
    },
    promoteApp: {
        downloadAppStore: 'Download on the App Store',
        downloadPlayStore: 'Get it on Google Play',
        title_read: 'Take your readings wherever you go with',
        title_audio: 'Take your audiobooks wherever you go with',
        text: 'Access your content whenever and however you want, without needing an internet connection, on the device of your choice. Download our app!',
        title_first_part: 'With',
        title_second_part: 'take your reading wherever you go',
    },
    dictionary: 'Dictionary',
    selectionTooLongLine1: 'The selection has too many words.',
    selectionTooLongLine2: 'Try selecting up to 5 words.',
    dictionaryValidation: {
        message: 'You selected {count} words.\nPlease try selecting up to {max} words.',
    },
    translateValidation: {
        message: 'You selected {count} characters.\nPlease try selecting up to {max} characters.',
    },
    ttsValidation: {
        message: 'You selected {count} characters.\nPlease try selecting up to {max} characters.',
    },
    aiValidation: {
        message: 'You selected {count} characters.\nPlease select between {min} and {max} characters.',
    },
    alreadyPurchased: 'Already purchased?',
    logIn: 'Log in',
    addToAList: 'Add to a list',
    lists: 'Lists',
    nextSection: 'Next section',
    prevSection: 'Previous section',
    new: 'New',
    skipLinks: {
        navLabel: 'Skip links',
        showControls: 'Show controls',
    },
    accessibility: {
        textSelected: '{count} characters selected. Selection tools available.',
        pageChanged: 'Page {current} of {total}',
    },
};
